import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import routes from "../../../../routes/routes";
import { getKeyWithTermsOfServiceInLowercase } from "../../../../util/utilFunctions";

/**
 * Resolves the terms-and-conditions / data-protection link target for the
 * customer-data step. Falls back to the generic `/hints` index, but if the
 * tenant defines a dedicated "terms of service" hint page, links straight to
 * it. Extracted from the parcel / p2p / equipmentRental flows, which each
 * inlined this identical logic (issue #868).
 */
export const useDataProtectionPath = (): string => {
  const hintPages = useSelector((state: RootState) => state.hints.pages);
  if (hintPages) {
    const key = getKeyWithTermsOfServiceInLowercase(hintPages);
    if (key) {
      return routes.makeHintsPath(key);
    }
  }
  return "/hints";
};
